import styled from 'styled-components';

export const Video = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  video {
    width: 60%;
    height: 50%;
    border-radius: 5px;
  }
`;
